<template>
  <div class="container top-0 position-sticky z-index-sticky">
    <div class="row">
      <div class="col-12">
        </div>
    </div>
  </div>
  <main class="mt-0 main-content">
    <section>
      <div class="page-header min-vh-100">
        <div class="container">
          <div class="row">
            <div class="mx-auto col-xl-4 col-lg-5 col-md-7 d-flex flex-column mx-lg-0">
              <img :src="logo" style="max-width:50%;" class="mx-auto"/>

              <div class="card card-plain">
                <div class="pb-0 card-header text-start">
                  <h4 class="font-weight-bolder">Bienvenido a Tracking App</h4>
                  <p class="mb-0">Introduzca sus credenciales para iniciar sesión</p>
                </div>

                <div class="card-body">
                  <form @submit.prevent="login">

                    <div class="mb-3">
                      <div class="input-group input-group-lg">
                        <input
                          type="text"
                          placeholder="Email o Nombre de Usuario"
                          name="username"
                          class="form-control"
                          v-model="user.username"
                          required
                        />
                      </div>
                    </div>

                    <div class="mb-3">
                      <div class="input-group input-group-lg">
                        <input
                          :type="passwordFieldType"
                          placeholder="Contraseña"
                          name="password"
                          class="form-control"
                          v-model="user.password"
                          style="border-right: none;"
                          required
                        />

                        <span
                          class="input-group-text password-toggle"
                          @click="togglePasswordVisibility"
                        >
                          <i
                            :class="passwordFieldType === 'password' ? 'fas fa-eye' : 'fas fa-eye-slash'"
                          ></i>
                        </span>
                      </div>

                      <small class="mx-auto mb-4 text-sm">
                        ¿Olvidó su contraseña?
                        <router-link
                          :to="{ name: 'Forgot' }"
                          class="text-success font-weight-bold"
                        >Recuperar contraseña</router-link>
                      </small>
                    </div>

                    <argon-switch id="rememberMe">Recordar</argon-switch>

                    <div class="text-center">
                      <argon-button
                        type="submit"
                        class="mt-4"
                        color="success"
                        fullWidth
                        size="lg"
                      >Acceder</argon-button>
                    </div>
                  </form>
                </div>

                <div class="px-1 pt-0 text-center card-footer px-lg-2">
                  <p class="mx-auto mb-4 text-sm">
                    ¿Aún no tienes una cuenta?
                    <router-link
                      :to="{ name: 'Signup' }"
                      class="text-success font-weight-bold"
                    >Registrarse</router-link>
                  </p>
                </div>
              </div>
            </div>
          </div>

          <div class="row">
            <footer class="footer pb-3">
              <div class="container">
                <div class="row align-items-center justify-content-lg-between">
                  <div class="col-lg-6 mb-lg-0 mb-4">
                    <div class="copyright text-center text-sm text-muted text-lg-start">
                      © {{ new Date().getFullYear() }}, Creado por
                      <a href="https://therealdevs.pro" class="font-weight-bold text-dark" target="_blank">
                        therealdevs.pro
                      </a>.
                      Todos los derechos reservados.
                    </div>
                  </div>
                </div>
              </div>
            </footer>
          </div>
        </div>
      </div>
    </section>
  </main>
</template>

<script>
// NOTA: Se mantiene ArgonSwitch y ArgonButton ya que son componentes complejos.
import ArgonSwitch from "@/components/ArgonSwitch.vue";
import ArgonButton from "@/components/ArgonButton.vue";
import axios from 'axios';
import Swal from 'sweetalert2';
import logo from "@/assets/img/logo.png";

const body = document.getElementsByTagName("body")[0];

export default {
  name: "signin",
  components: {
    // ArgonInput ha sido removido de aquí
    ArgonSwitch,
    ArgonButton,
  },
  data(){
    return{
      logo,
      passwordFieldType: 'password',
      user:{
        username:null,
        password:null,
      }
    }
  },
  created() {
    this.$store.state.hideConfigButton = true;
    this.$store.state.showNavbar = false;
    this.$store.state.showSidenav = false;
    this.$store.state.showFooter = false;
    body.classList.remove("bg-gray-100");
  },
  beforeUnmount() {
    this.$store.state.hideConfigButton = false;
    this.$store.state.showNavbar = true;
    this.$store.state.showSidenav = true;
    this.$store.state.showFooter = true;
    body.classList.add("bg-gray-100");
  },
  methods:{
    // Alterna la visibilidad
    togglePasswordVisibility() {
        this.passwordFieldType =
            this.passwordFieldType === 'password' ? 'text' : 'password';
    },

    login() {
      // ... (Tu lógica de login se mantiene intacta) ...
      let self = this;
      console.log(self.user);

      axios.post(self.$store.state.apiURL + 'login', self.user)
        .then((result) => {
          console.log(result);
          localStorage.setItem('userId', result.data.id);
          localStorage.setItem('userEmail', result.data.email);
          localStorage.setItem('userFullName', result.data.full_name);
          localStorage.setItem('userName', result.data.username);
          localStorage.setItem('userLevel', result.data.role_id);
          localStorage.setItem('accessToken', result.data.token);
          localStorage.setItem('companyId', result.data.company);
          localStorage.setItem('branchId', result.data.branch);
          this.updateTrackingConfig();
          if(result.data.role_id==3){
            self.$router.push('/tasks/my');
          }else{
            self.$router.push('/dashboard');
          }

        })
        .catch((err) => {
          console.error("Fallo de autenticación o conexión:", err);
          Swal.fire({
            title: 'Fallo de Sesión',
            text: 'Credenciales incorrectas, ingresa nuevamente.',
            icon: 'warning',
            showCancelButton: false,
            confirmButtonColor: '#bf4f51',
            showCloseButton: true,
            showLoaderOnConfirm: false
          });
        });
    },

    updateTrackingConfig() {
      const token = localStorage.getItem("accessToken");
      const userId = localStorage.getItem('userId');
      const apiURL = `${this.$store.state.apiURL}tracking_log`;

      if (!token || !userId) return;

      if (window.cordova) {
        // Llamamos directamente a la acción que creamos en Java
        window.cordova.exec(
          (win) => console.log("✅ Sincronización Exitosa:", win),
          (err) => console.error("❌ Error Sincronización:", err),
          "BackgroundMode",      // El nombre del plugin
          "saveTrackingData",    // La acción que creamos
          [{ apiURL, token, userId }] // Los datos
        );
      }
    }
  }
}
</script>

<style scoped>
/* Estilos para el input group */
.password-toggle {
    /* Estilos para que el ojo se vea bien en el input-group */
    cursor: pointer;
    background-color: white;
    border-left: none;
    border-color: #dee2e6; /* Color del borde de Bootstrap */
    padding-right: 15px;
}
</style>